/* src/app/ship/ship-from/ship-from.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.address-book-search {
  font-size: 1rem;
}
.address-book-search .mat-mdc-raised-button {
  font-size: 0.8125em;
  font-weight: 500;
  height: 35px;
  width: 110px;
  padding: 0 0.4375em;
}
.address-book-search .mat-mdc-raised-button.address-book-search-button-french * {
  font-size: 0.65625em !important;
}
.ship-from {
  width: 100%;
}
.ship-from .select-wrapper {
  position: relative;
}
.ship-from .ship-from-edit {
  margin: 0 2em;
}
.ship-from .form-section-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.ship-from .form-section-header .form-section-actions {
  margin: 0;
}
.ship-from .location-selector-wrapper {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
  flex-wrap: wrap;
}
.ship-from .location-selector-wrapper .location-selector {
  display: flex;
  flex: 1;
}
.ship-from .location-selector-wrapper .edit-location {
  font-size: 0.8125em;
  letter-spacing: 0.5px;
  padding: 1em 0 0 1em;
  margin-left: auto;
}
.ship-from upsc-ship-from-static {
  margin-top: -1em;
}
/*# sourceMappingURL=ship-from.component.css.map */
